import React from "react";
import { useAuth } from "./context/auth";
import { Outlet, Navigate } from "react-router-dom";
import Login from "./components/+login/Login";

function PrivateRoute() {
    const { authenticated, submitter } = useAuth();
    if (submitter) {
        return <Navigate to="/submitter/jobs" />;
    }
    return authenticated ? <Outlet /> : <Login />;
}

export default PrivateRoute;